import { render, staticRenderFns } from "./createDebtManagementInvestigation.vue?vue&type=template&id=abcffb62"
import script from "./createDebtManagementInvestigation.ts?vue&type=script&lang=js&external"
export * from "./createDebtManagementInvestigation.ts?vue&type=script&lang=js&external"
import style0 from "./createDebtManagementInvestigation.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports